



















































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import CardListPasienPenunjang from "@/components/dashboard/CardListPasienPenunjang.vue";
import CardListPasienGizi from "@/components/gizi/CardListPasienGizi.vue";
import TanggalGizi from "@/components/gizi/TanggalGizi.vue";
import ListPasienTransferInternal from "@/components/pti/ListPasienTransferInternal.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { pusher } from "@/services/PusherClient";
import ListPasien from "@/services/ListPasien";
import PasienNew from "@/services/PasienNew";
import EncounterIndex from "@/services/EncounterIndex";
import {
  isDaftarPasienUnitTanpaTab,
  isInstalasiGizi,
  isPemeriksaanRingkas,
  isRanap,
  pemeriksaanRouteName
} from "@/utils/unit";
import {
  bukaPemeriksaanGizi,
  bukaRiwayatPasien,
  formatUmur
} from "@/utils/gizi";
import { PasienGiziRow } from "@/types/orderGizi";
import { localISODate } from "@/utils/localDate";
import {
  PasienPenunjangRow,
  PasienTagByRm,
  UnitAsalOption
} from "@/types/daftarPasienPenunjang";

@Component({
  components: {
    CardListPasienPenunjang,
    CardListPasienGizi,
    ListPasienTransferInternal,
    TanggalGizi,
    VCDateTimePicker
  },
  beforeRouteLeave(to, from, next) {
    pusher.unsubscribe(`pemeriksaan.unit.${this.sess_login["unit_id"]}`);

    next();
  }
})
export default class DaftarPasienUnit extends Vue {
  cm = "";
  tab = 0;
  pasienSudah: PasienPenunjangRow[] = [];
  pasienBelum: PasienPenunjangRow[] = [];
  pasienTagByRm: PasienTagByRm = {};
  unitAsalOptions: UnitAsalOption[] = [];
  hdn = "";
  loading = true;
  showFilterDokter = true;
  errListPx = "0";
  errPx = "0";
  reg = "";
  sess_login = this.stateuser;

  tgl: string = localISODate();
  unitAsal: string | null = null;
  cariGizi = "";

  private reqToken = 0;

  mounted() {
    appModule.setLoading(true);
    this.$root.$on("reload-ranap-global", this.GetPasien);
    this.GetPasien();
  }

  beforeDestroy() {
    this.$root.$off("reload-ranap-global", this.GetPasien);
  }

  get tanpaTab(): boolean {
    return isDaftarPasienUnitTanpaTab(this.sess_login["unit_id"]);
  }

  get modeGizi(): boolean {
    return isInstalasiGizi(this.sess_login["unit_id"]);
  }

  get barisGizi(): PasienGiziRow[] {
    const cari = (this.cariGizi || "").toLowerCase().trim();

    return this.pasienSudah
      .filter(row => {
        if (!cari) return true;
        const nama = String((row.pasien && row.pasien.nama) || "").toLowerCase();
        const rm = String((row.pasien && row.pasien.rm) || "");
        return nama.includes(cari) || rm.includes(cari);
      })
      .map(row => ({
        row_key: row.row_key,
        register_id: String(row.register_id || ""),
        rm: row.pasien ? row.pasien.rm : "",
        nama: row.pasien ? row.pasien.nama : null,
        sex: row.pasien ? row.pasien.sex : null,
        umur: formatUmur(row.pasien ? row.pasien.umur : null),
        unit_id: row.unit ? row.unit.id : null,
        unit_nama: row.unit ? row.unit.nama : null,
        episode_ranap: isRanap(row.unit ? row.unit.id : null),
        dokter_nama: row.dokter ? row.dokter.nama : null,
        jam: row.jam,
        cara_bayar: row.cara_bayar ? row.cara_bayar.nama : null
      }));
  }

  get stateuser() {
    return userModule.user;
  }

  get tglDate(): Date | null {
    if (!this.tgl) {
      return null;
    }

    const p = this.tgl.split("-").map(Number);

    return new Date(p[0], p[1] - 1, p[2]);
  }

  setTgl(val: Date | null) {
    this.tgl = val ? localISODate(val) : localISODate();
  }

  get pasienAktif(): PasienPenunjangRow[] {
    return this.tab === 1 && !this.tanpaTab
      ? this.pasienBelum
      : this.pasienSudah;
  }

  get showLoading() {
    return appModule.loading;
  }

  @Watch("tgl")
  @Watch("unitAsal")
  onFilterChange() {
    this.GetPasien();
  }

  GetPasien() {
    this.loading = true;
    this.errListPx = "0";

    const token = ++this.reqToken;

    ListPasien.getListPasienPenunjang(
      this.tgl,
      this.sess_login["unit_id"],
      this.unitAsal || ""
    )
      .then(dt => {
        if (token !== this.reqToken) return;

        this.pasienSudah = Array.isArray(dt.data) ? dt.data : [];
        this.pasienBelum = Array.isArray(dt.data_belum) ? dt.data_belum : [];
        this.unitAsalOptions = Array.isArray(dt.unit_asal) ? dt.unit_asal : [];
        this.hdn = "";
        this.loadPasienTag(token);
      })
      .catch(() => {
        if (token !== this.reqToken) return;

        this.errListPx = "1";
        this.pasienSudah = [];
        this.pasienBelum = [];
        this.pasienTagByRm = {};
      })
      .finally(() => {
        if (token !== this.reqToken) return;

        this.loading = false;
        appModule.setLoading(false);
      });
  }

  loadPasienTag(token: number) {
    const rms = Array.from(
      new Set(
        [...this.pasienSudah, ...this.pasienBelum]
          .map(row => (row.pasien && row.pasien.rm ? row.pasien.rm : ""))
          .filter(rm => rm !== "")
      )
    );

    if (!rms.length) {
      this.pasienTagByRm = {};
      return;
    }

    PasienNew.getMultiPasienTag(rms)
      .then((resp: PasienTagByRm) => {
        if (token !== this.reqToken) return;

        this.pasienTagByRm = resp && !Array.isArray(resp) ? resp : {};
      })
      .catch(() => undefined);
  }

  reloadListPx() {
    this.errListPx = "0";
    this.GetPasien();
  }

  async dataPasien(payload) {
    const item = payload && payload.item;
    if (!item || !item.register_id || !item.pasien) return;

    const name = isPemeriksaanRingkas(this.sess_login["unit_id"])
      ? "pemeriksaan"
      : pemeriksaanRouteName(item.unit ? item.unit.id : null);
    if (name === "pemeriksaan-ranap") {
      await EncounterIndex.regRanap(item.register_id, item.pasien.rm).catch(
        () => undefined
      );
    }

    this.$router.push({
      name: name,
      params: {
        register: item.register_id,
        rm: item.pasien.rm
      }
    });
  }

  bukaPasienGizi(row: PasienGiziRow, pemantauan: boolean) {
    if (!row.register_id || !row.rm) return;

    bukaPemeriksaanGizi(
      this.$router,
      { register_id: row.register_id, rm: row.rm, unit_id: row.unit_id },
      pemantauan
    );
  }

  bukaRiwayatGizi(row: PasienGiziRow) {
    bukaRiwayatPasien(this.$router, row.rm);
  }
}
